import React from 'react';
import t from '~t';
import _ from 'lodash';
import config from '~config';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { user as getUser } from '~data/selectors/user';
import { API_ENDPOINT_URL } from '~data/constants/app';
import { target } from '~target';

import { Label, Checkbox, Alert, Icon } from '~ui';

function ConnectionError() {
  const { search } = useLocation();
  const { connect_error = '' } =
    Object.fromEntries(new URLSearchParams(search)) || {};

  if (!connect_error) return null;

  let content;

  switch (connect_error) {
    case 'conflict':
      content = <span>{t.s('connectConflict')}</span>;
      break;

    default:
      content = connect_error;
      break;
  }

  return <Alert variant='danger'>{content}</Alert>;
}

export default function SettingsProfileConnect() {
  const { pathname } = useLocation();
  const user = useSelector((state) => getUser(state));

  return (
    <>
      <Label>{t.s('signInSocial')}</Label>

      {target == 'web' ? (
        <div>
          <ConnectionError />

          {['google', 'apple'].map((key) => {
            const enabled = user[key] && user[key].enabled;

            return (
              <Checkbox
                key={key}
                checked={enabled}
                onChange={() =>
                  (window.location = `${API_ENDPOINT_URL}user/connect/${key}/${
                    enabled ? 'revoke' : ''
                  }`)
                }
                className={enabled ? 'ui-connect-enabled' : 'ui-connect-default'}
              >
                <Icon name={key} className={'ui-connect-icon' + ' ' + key} />
                {_.capitalize(key)}
              </Checkbox>
            );
          })}
        </div>
      ) : (
        <Alert variant='warning'>
          {t.s('openWebAppSocial')}{' '}
          <a href={`${config.links.app.index}${pathname}`} target='_blank'>
            {t.s('openInBrowser')}
          </a>
        </Alert>
      )}
    </>
  );
}
